import React, {createContext, useState} from "react";
import PMSCustomerServices from "../../services/pms_services/PMSCustomerServices";
import Notification from "../../components/common/Notification";

export const PMSCustomerLedgerContext = createContext("PMSCustomerLedgerContext");

const PMSCustomerLedgerContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [ledgerEntries, setLedgerEntries] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [closingBalance, setClosingBalance] = useState(0);

    const getCustomerLedger = async (customerId, params) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await PMSCustomerServices.getCustomerLedger(customerId, params);
            setLedgerEntries(res.data.content);
            setTotalElements(res.data.totalElements);
            setClosingBalance(res.data.closingBalance);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            let _error = "Something went wrong.";
            if (error.message === "Network Error") _error = error.message;
            if (error.response && error.response.data) _error = error.response.data.message;
            setErrorMsg(_error);
            Notification("error", "ERROR", `${_error}`);
            return false;
        }
    };

    const downloadCustomerLedger = async (customerId, params) => {
        try {
            setLoadingDownload(true);
            const res = await PMSCustomerServices.downloadCustomerLedger(customerId, params);
            if (res && res.data) {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", res.headers["content-disposition"].split("filename=")[1]);
                document.body.appendChild(link);
                link.click();
            }
            setLoadingDownload(false);
            return true;
        } catch (error) {
            setLoadingDownload(false);
            let _error = "Something went wrong.";
            if (error.message === "Network Error") _error = error.message;
            if (error.response && error.response.data) _error = error.response.data.message;
            Notification("error", "ERROR", `${_error}`);
            return false;
        }
    };

    return (
        <PMSCustomerLedgerContext.Provider
            value={{
                loading,
                loadingDownload,
                errorMsg,
                ledgerEntries,
                totalElements,
                closingBalance,
                getCustomerLedger,
                downloadCustomerLedger,
            }}
        >
            {children}
        </PMSCustomerLedgerContext.Provider>
    );
};

export default PMSCustomerLedgerContextProvider;
